import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import NonconformDetail from '../components/nonconformity/NonconformDetail';
import NonconformList from '../components/nonconformity/NonconformList';
import * as securityHelper from "../helper/SecurityHelper";
import axios from "axios";
import Snackbar from '../components/Snackbar';

interface Nonconform {
  name: string;
  place: string;
  content: string;
  image: string;
  status: string;
  doneImage: string;
  requestCom: string;
  key: number;
}

export default function Nonconformity() {
  const navigate = useNavigate();
  const auth = securityHelper.getLoginUser().auth;
  const [inOut, setInOut] = useState('in');
  const [detail, setDetail] = useState(false);
  const [nonconform, setNonconform] = useState<Nonconform[]>([]);
  const [detailData, setDetailData] = useState<Nonconform>();
  const [date, setDate] = useState<Date>(new Date());
  const user: any = securityHelper.getLoginUser();
  const [snackbarTxt, setSnackbarTxt] = useState('');
  useEffect(() => { setTimeout(() => setSnackbarTxt(''), 2000) }, [snackbarTxt]);

  const backEvent = () => {
    if (!detail) { navigate(-1) }
    else { setDetail(false) };
  }

  const fn_retrieveNCnfrmtyDataList = async (date: any) => {

    let param = {};

    if (user.auth === 'COM') {
      if (inOut === 'in') {
        param = { hstCmpnySeq: user.companySeq };
      } else {
        param = { rgstCmpnySeq: user.companySeq };
      }

    } else if (user.auth === 'KOX') {
      param = { rgstCmpnySeq: user.companySeq };
      if (date) {
        // @ts-ignore
        param.rgstDt = date;
      }
    } else if (user.auth === 'SRV') {
      param = { chkTrgtCmpnySeq: user.companySeq };
      if (date) {
        // @ts-ignore
        param.rgstDt = date;
      }
    }

    const rtrnData = await axios.post('admin/api/sftyChk/retrieveNCnfrmtyDataList', param)
    console.log('rtrnData: ', rtrnData.data);
    setNonconform(rtrnData.data)
  }
  useEffect(() => {
    // @ts-ignore
    if (user.auth == 'COM') {
      fn_retrieveNCnfrmtyDataList(null);
    }

  }, [inOut])
  useEffect(() => {
    // axios 로 날짜에 따른 데이터 가져오기
    if (date) {
      fn_retrieveNCnfrmtyDataList(date);
    }

  }, [date])

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      <NavbarText backEvent={backEvent}>부적합 관리</NavbarText>
      {!detail
        ? <NonconformList inOut={inOut} setInOut={setInOut} nonconform={nonconform} setDetail={setDetail} setDetailData={setDetailData} auth={auth} date={date} setDate={setDate} />
        : <NonconformDetail detailData={detailData} auth={auth} setDetail={setDetail} setSnackbarTxt={setSnackbarTxt} />}
    </div>
  );
}

